
<b-form-group v-bind="$props">
  <b-form-input v-model="item[field]"
                :placeholder="placeholder"
                :disabled="disabled"
                :required="required"
                :type="type"
                :step="step"
                :pattern="pattern"
                @change="$emit('change',$event)"
                @input="$emit('input',$event)">

  </b-form-input>
</b-form-group>

